import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../app/views/Home.vue'
import Onboarding from '../app/views/Onboarding.vue'
import Login from '../app/views/Login.vue'
import Newsletter from '../app/views/Newsletter.vue'
import Track from '../app/views/Track.vue'
import Result from '../app/views/Result.vue'
import End from '../app/views/End.vue'
import PlaylistFavorite from '../app/views/PlaylistFavorite.vue'
import PlaylistSort from '../app/views/PlaylistSort.vue'
import Breaker from '../app/views/Breaker.vue'
import Album from '../app/views/Album.vue'
import Playlist from '../app/views/Playlist.vue'
import SearchTracks from '../app/views/SearchTracks.vue'
import Chart from '../app/views/Chart.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: Onboarding
  },
  {
    path: '/playlist-favorite/:id',
    name: 'PlaylistFavorite',
    component: PlaylistFavorite
  },
  {
    path: '/playlist-sort',
    name: 'PlaylistSort',
    component: PlaylistSort
  },
  {
    path: '/breaker/:id',
    name: 'Breaker',
    component: Breaker
  },
  {
    path: '/search-tracks',
    name: 'SearchTracks',
    component: SearchTracks
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/login-page', // needded to enter login for testing
    name: 'LoginPage',
    component: Login
  },
  {
    path: '/newsletter',
    name: 'Newsletter',
    component: Newsletter
  },
  {
    path: '/track/:id',
    name: 'Track',
    component: Track
  },
  {
    path: '/album/:name',
    name: 'Album',
    component: Album
  },
  {
    path: '/playlist/:id',
    name: 'Playlist',
    component: Playlist
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
  {
    path: '/end',
    name: 'End',
    component: End
  },
  {
    path: '/chart',
    name: 'Chart',
    component: Chart
  },
  {
    path: '/connect-account',
    name: 'ConnectAccount',
    component: () => import('../app/views/ConnectArtistAccount.vue'),
    meta: {
      noStepRedirect: true,
      noEndRedirect: true,

    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
